module.exports = __webpack_public_path__ + "04bc505ceef2e1e37ebb47e5e60f0ff4.svg";